module.exports = __webpack_public_path__ + "img/main.72c4a7ea.png";